import { TConfiguracaoFormularioIdeias, TConfiguracaoCampoIdeia } from "@/modules/configuracao-formulario-ideias";

type ValidatedFieldKey = "descricao" | "diferenciais" | "comoAtingirObjetivo" | "feedback" | "descricaoProblema";

/**
 * Retorna uma lista de campos obrigatórios para a publicação de uma ideia,
 * com base na configuração do formulário.
 * @param configuracao - A configuração do formulário de ideias.
 * @returns Uma lista de chaves de campos obrigatórios.
 */
export function getRequiredFieldsForPublish(configuracao?: TConfiguracaoFormularioIdeias): ValidatedFieldKey[] {
  const baseFields: ValidatedFieldKey[] = ["descricao"];

  if (!configuracao) {
    return ["descricao", "diferenciais", "comoAtingirObjetivo", "feedback", "descricaoProblema"];
  }

  const optionalFields: Array<{ key: ValidatedFieldKey; configKey: keyof typeof configuracao }> = [
    { key: "diferenciais", configKey: "diferenciais" },
    { key: "comoAtingirObjetivo", configKey: "comoAtingirObjetivo" },
    { key: "feedback", configKey: "feedback" },
    { key: "descricaoProblema", configKey: "descricaoProblema" }
  ];

  for (const { key, configKey } of optionalFields) {
    const fieldConfig = configuracao[configKey] as TConfiguracaoCampoIdeia;
    if (fieldConfig?.visivel) {
      baseFields.push(key);
    }
  }

  return baseFields;
}
